<template>
  <div
    v-if="userCanOverridePrice && bookingReserveResponse"
  >
    <button
      :disabled="overrideInProgress || disabled"
      class="btn btn-block btn-primary"
      @click="showOverrideConfirm"
    >
      Override Price
    </button>
    <modal
      name="booking-override-modal"
    >
      <div class="container">
        <div class="row">
          <a
            :disabled="overrideInProgress || disabled"
            class="button button--ghost product__info-close"
            @click="hideOverrideConfirm"
          ><span class="visuallyhidden">Close</span></a>
        </div>
        <div class="row">
          <div class="col-12 mt-4">
            <h3 class="text-center">
              Override Parking Price
            </h3>
            <label>
              Base Parking Price
            </label>
            <input
              v-model="price"
              :disabled="true"
              class="form-control"
            >
            <label class="mt-2">
              New Parking Price
            </label>
            <input
              v-model="priceOverrideValue"
              :disabled="overrideInProgress || disabled"
              class="form-control"
            >
          </div>
        </div>
        <div class="row">
          <div class="col-12 ">
            <button
              :disabled="overrideInProgress || disabled"
              class="btn btn-info mt-4"
              @click="hideOverrideConfirm"
            >
              No, close
            </button>
            <button
              :disabled="$v.$invalid || overrideInProgress || disabled"
              class="btn btn-danger mt-4 pull-right"
              @click="overridePrice"
            >
              Yes, confirm {{ $n(priceOverrideValue, 'currency', languageCode) }}
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ErrorHandling from '../../../lib/error-handling.js'
import { required, minValue, maxValue, between } from 'vuelidate/lib/validators'
const isDecimal = (value) => /^\d*\.?\d*$/.test(value)

export default {
    name: 'OverridePrice',
    props: {
        bookingId: {
            type: String,
            default: null
        },
        price: {
            type: Number,
            default: 0.00
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            priceOverrideValue: 0.00,
            priceOverrideReason: '',
            overrideInProgress: false
        }
    },
    computed: {
        ...mapState({
            bookingReserveResponse: state => state.booking.bookingReserveResponse
        }),
        ...mapGetters({ userCanOverridePrice: 'auth/userCanOverridePrice' }),
        languageCode () {
            var code = this.$store.getters['getLanguageCode']({
                identifier: this.$store.state.airport.selectedAirportId
            })
            if (code !== null) {
                return code
            }
            return 'en-GB'
        },
        totalBookingPrice () {
            var totalExtrasPrice = 0
            if (this.bookingReserveResponse.data.booking.items.extras) {
                for (var i = 0; i < this.bookingReserveResponse.data.booking.items.extras.length; i++) {
                    totalExtrasPrice = totalExtrasPrice + this.bookingReserveResponse.data.booking.items.extras[i].offerLines.reduce((total, offerLine) => { return total + parseFloat(offerLine.amount) }, 0)
                }
            }
            return parseFloat(this.priceOverrideValue) + totalExtrasPrice
        }
    },
    created () {
        this.priceOverrideValue = this.price
    },
    validations: {
        priceOverrideValue: {
            required,
            between (value) {
                return between(0, this.price)(value)
            }
        }
    },
    methods: {
        showOverrideConfirm () {
            this.$modal.show('booking-override-modal')
        },
        hideOverrideConfirm () {
            this.$modal.hide('booking-override-modal')
        },
        async overridePrice () {
            this.overrideInProgress = true
            var forceCancel = true

            var result = await this.$store.dispatch('overridePrice',
                [
                    this.bookingReserveResponse.data.booking.id,
                    this.totalBookingPrice
                ])
            if (result.status === 200) {
                this.$toasted.success(`Price updated to ${this.priceOverrideValue}`)
                this.$store.dispatch('setBookingReserveResponse', result)
                this.$store.dispatch('setOverrideParkingPrice', parseFloat(this.priceOverrideValue))
                this.hideOverrideConfirm()
                this.$v.$touch()
            } else {
                this.$toasted.error(`Not Cancelled. ${result.data}`)
            }
            //
            this.overrideInProgress = false
        }
    }
}
</script>
